import * as XLSX from 'xlsx';

export const parseExcelFile = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = e.target?.result;
                const workbook = XLSX.read(data, { type: 'binary' });
                const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

                const students = jsonData.slice(1)
                    .filter(row => row.length > 0 && row[1])
                    .map((row, index) => {
                        const studyTypeRaw = String(row[10] || 'kunduzgi').trim().toLowerCase();
                        const studyType = studyTypeRaw.includes('sirtqi') || studyTypeRaw.includes('заочн')
                            ? 'sirtqi'
                            : 'kunduzgi';

                        return {
                            id: `student-${index + 1}`,
                            name: String(row[1] || '').trim(),
                            group: String(row[7] || 'Группа не указана').trim(),
                            studyType,
                            confirmed: false,
                        };
                    });

                resolve(students);
            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = () => {
            reject(new Error('Ошибка чтения файла'));
        };

        reader.readAsBinaryString(file);
    });
};

export const groupStudentsByGroup = (students) => {
    const groupMap = new Map();

    students.forEach(student => {
        const groupName = student.group || 'Без группы';
        if (!groupMap.has(groupName)) {
            groupMap.set(groupName, []);
        }
        groupMap.get(groupName).push(student);
    });

    const groups = Array.from(groupMap.entries()).map(([name, students], index) => ({
        id: `group-${index + 1}`,
        name,
        students,
        confirmedCount: students.filter(s => s.confirmed).length,
        totalCount: students.length,
    }));

    groups.sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    return groups;
};

export const distributeGroupsByDays = (groups, studentsPerDay = 680) => {
    const days = [];
    let currentDay = { groups: [], totalStudents: 0 };

    groups.forEach(group => {
        if (currentDay.totalStudents + group.totalCount > studentsPerDay && currentDay.groups.length > 0) {
            days.push(currentDay);
            currentDay = { groups: [], totalStudents: 0 };
        }
        currentDay.groups.push(group);
        currentDay.totalStudents += group.totalCount;
    });

    if (currentDay.groups.length > 0) {
        days.push(currentDay);
    }
    return days;
};

export const saveToLocalStorage = (key, data) => {
    try {
        localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
        console.error('Error saving to localStorage:', error);
    }
};

export const loadFromLocalStorage = (key) => {
    try {
        const data = localStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    } catch (error) {
        console.error('Error loading from localStorage:', error);
        return null;
    }
};
